import React from "react";
import {
  LineSeperator,
  SubHeader,
  Paragraph,
} from "../RegularComponents";
import {
  APPLICATION_MODE_RENEW,
  APPLICATION_TYPE_MORTGAGE_LENDER_LICENCE,
  APPLICATION_TYPE_MORTGAGE_ADMINISTRATOR_LICENCE,
} from "../../app/constants";

const CompliaceOfficerConfirm = (props) => {
  if (
    !(
      props.applicationType === APPLICATION_TYPE_MORTGAGE_LENDER_LICENCE ||
      props.applicationType === APPLICATION_TYPE_MORTGAGE_ADMINISTRATOR_LICENCE
    )
  ) {
    return null;
  }

  if (props.applicationMode !== APPLICATION_MODE_RENEW) {
    return null;
  }

  return (
    <div>
      <LineSeperator style={{ borderColor: "#777", borderWidth: "2px" }} />
      <SubHeader
        subHeader={"Compliance Officer is one of the individuals above"}
      />
      <Paragraph
        id="rjsc-detail-review-text"
        text={[
          "You, as the compliance officer for your company, have to be listed as a director, partner, officer or sole proprietor with the Registry of Joint Stocks Companies.",
          "Is your name on the above list?"
        ]}
      />

      {/* <CheckboxForm
        id="confirm-before-start-checkbox"
        checked={props.complaiceOfficerCheck}
        value={props.complaiceOfficerCheck}
        labelText="Yes, my name is on the list above."
        onCheckBoxChange={(val) => {
          props.setUnmatchedComplianceOfficerError(false);
          props.setComplaiceOfficerCheck(val);
        }}
      />
      {props.unmatchedComplianceOfficerError && ErrorMark()}
      {props.unmatchedComplianceOfficerError && (
        <div className="ns-error-message">
          <span className="ns-visually-hidden">Error:</span>
          {ERROR_STRING.CONFIRM_BEFORE_CONTINUE}
        </div>
      )} */}
    </div>
  );
};

export default CompliaceOfficerConfirm;
